import React, { useState, useEffect } from "react";

import "./SubStyle.css";
import prop_1 from "../images/property1.png"
import prop_2 from "../images/property2.png"
import prop_3 from "../images/property3.png"

/* =========================================================
   DATA
========================================================= */

const stats = [
  {
    value: "100+",
    label: "Care businesses supported",
  },
  {
    value: "£50M+",
    label: "Transaction value supported",
  },
  {
    value: "15+",
    label: "Years of sector experience",
  },
  {
    value: "UK",
    label: "Specialist care sector coverage",
  },
];

const reasons = [
  {
    number: "01",
    title: "Care Sector Expertise",
    description:
      "Specialist knowledge of care homes, operators, regulation and the commercial realities of the sector.",
  },
  {
    number: "02",
    title: "Confidential Approach",
    description:
      "We understand the importance of protecting your business, staff and reputation during a sale.",
  },
  {
    number: "03",
    title: "Commercial Focus",
    description:
      "We focus on achieving the right commercial result, not simply completing a transaction.",
  },
  {
    number: "04",
    title: "End-to-End Support",
    description:
      "From the initial valuation through negotiation, due diligence and completion, we're with you.",
  },
];

const processSteps = [
  {
    number: "01",
    title: "Initial Consultation",
    description:
      "We understand your objectives, property and ideal transaction before creating a tailored sales strategy.",
  },
  {
    number: "02",
    title: "Valuation & Preparation",
    description:
      "Our team assesses your care home and prepares the information required to position the opportunity effectively.",
  },
  {
    number: "03",
    title: "Confidential Marketing",
    description:
      "We present your care home to suitable buyers while maintaining confidentiality throughout the process.",
  },
  {
    number: "04",
    title: "Negotiation",
    description:
      "We manage enquiries, offers and negotiations to help you achieve the strongest possible outcome.",
  },
  {
    number: "05",
    title: "Due Diligence",
    description:
      "We support the transaction through due diligence, documentation and communication with relevant parties.",
  },
  {
    number: "06",
    title: "Completion",
    description:
      "We remain involved through completion to help keep the transaction moving smoothly.",
  },
];

const opportunities = [
  {
    image: prop_1,
    status: "For Sale",
    name: "Greenfield Care Home",
    location: "Surrey",
    type: "Residential Care",
    beds: "45 Beds",
    price: "£1,850,000",
  },
  {
    image: prop_2,
    status: "Under Offer",
    name: "Meadow View Care Home",
    location: "Manchester",
    type: "Nursing Care",
    beds: "38 Beds",
    price: "£1,250,000",
  },
  {
    image: prop_3,
    status: "For Sale",
    name: "Riverside Care Home",
    location: "Birmingham",
    type: "Residential Care",
    beds: "30 Beds",
    price: "£950,000",
  },
];

const listings = [
  {
    name: "Greenfield Care Home",
    location: "Surrey",
    type: "Residential",
    beds: "45",
    price: "£1,850,000",
    status: "For Sale",
  },
  {
    name: "Meadow View Care Home",
    location: "Manchester",
    type: "Nursing",
    beds: "38",
    price: "£1,250,000",
    status: "Under Offer",
  },
  {
    name: "Riverside Care Home",
    location: "Birmingham",
    type: "Residential",
    beds: "30",
    price: "£950,000",
    status: "For Sale",
  },
  {
    name: "Woodlands Care Home",
    location: "Leeds",
    type: "Nursing",
    beds: "42",
    price: "£1,650,000",
    status: "Due Diligence",
  },
];

const faqs = [
  {
    question: "How do you value a care home?",
    answer:
      "We consider profitability, occupancy, location, property condition, operational performance and current market conditions to provide a realistic valuation.",
  },
  {
    question: "Can you sell my care home confidentially?",
    answer:
      "Yes. We use a confidential approach when marketing your care home and only share information with suitable buyers through the appropriate process.",
  },
  {
    question: "Do you help buyers find care homes?",
    answer:
      "Yes. We help buyers identify suitable opportunities based on their objectives, budget, location and operational requirements.",
  },
  {
    question: "Do you help with due diligence?",
    answer:
      "Yes. We support buyers and sellers throughout due diligence and help coordinate the required information and communication.",
  },
];

/* =========================================================
   HERO
========================================================= */

const SalesHero = () => {
  // open page on top //
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // open page on top //
  return (
    <section className="sales-hero">
      <div className="sales-hero-container">
        <div className="sales-hero-content">
          <span className="sales-hero-tag">EXPERTS IN CARE HOME SALES</span>

          <h1>
            Care homes for sale.
           
            <span>Trusted deals.</span> Better
           
            outcomes.
          </h1>

          <p>
            We help care home owners buy, sell and value care homes with
            confidence. From confidential marketing to due diligence and
            negotiation – we manage the process, so you get the right result.
          </p>

          <div className="sales-hero-buttons">
            <button className="blue-btn">
              <a href="#featured">View Available Homes</a>
            </button>

            <button className="outline-btn">
              <a
                href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
              >
                Book a Free Consultation
              </a>
            </button>
          </div>

          <div className="sales-hero-points">
            <span>✓ Confidential &amp; Secure</span>
            <span>✓ Expert Valuation</span>
            <span>✓ End-to-End Support</span>
          </div>
        </div>

        <SalesDashboard />
      </div>
      {/* Scroll Down */}
      <div className="scroll-down">
        <div className="mouse">
          <span></span>
        </div>

        <small>SCROLL DOWN</small>
      </div>
    </section>
  );
};

/* =========================================================
   DASHBOARD
========================================================= */

const SalesDashboard = () => {
  return (
    <div className="sales-dashboard">
      <div className="dashboard-header">
        <h2>Care Home Sales Overview</h2>

        <span className="dashboard-month">This Month&nbsp;⌄</span>
      </div>

      <div className="dashboard-stats">
        <div>
          <strong>28</strong>
          <small>Active Listings</small>
        </div>

        <div>
          <strong>6</strong>
          <small>This Month</small>
        </div>

        <div>
          <strong>7</strong>
          <small>In Progress</small>
        </div>

        <div>
          <strong>12</strong>
          <small>This Month</small>
        </div>

        <div>
          <strong>£1.42M</strong>
          <small>12% vs last month</small>
        </div>
      </div>

      <div className="dashboard-charts">
        <div className="dashboard-card">
          <h3>Properties by Region</h3>

          <div className="region-chart">
            <div className="region-donut"></div>

            <div className="region-values">
              <span>
                South East <b>40%</b>
              </span>
              <span>
                North West <b>20%</b>
              </span>
              <span>
                Midlands <b>15%</b>
              </span>
              <span>
                Yorkshire <b>15%</b>
              </span>
              <span>
                Others <b>10%</b>
              </span>
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Asking Price Range</h3>

          <div className="price-chart">
            <div>
              <i className="price-bar bar-one"></i>
              <span>&lt; £500K</span>
            </div>

            <div>
              <i className="price-bar bar-two"></i>
              <span>£500K-£1M</span>
            </div>

            <div>
              <i className="price-bar bar-three"></i>
              <span>£1M-£2M</span>
            </div>

            <div>
              <i className="price-bar bar-four"></i>
              <span>£2M+</span>
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Sale Pipeline</h3>

          <div className="pipeline-chart">
            <div className="pipeline-donut">
              <strong>14</strong>
              <small>Total</small>
            </div>

            <div className="pipeline-list">
              <span>
                <i></i> Initial Enquiry <b>5</b>
              </span>
              <span>
                <i></i> Valuation <b>4</b>
              </span>
              <span>
                <i></i> Due Diligence <b>3</b>
              </span>
              <span>
                <i></i> Negotiation <b>2</b>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-listings">
        <h3>Recent Listings</h3>

        <div className="dashboard-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Property Name</th>
                <th>Location</th>
                <th>Type</th>
                <th>Beds</th>
                <th>Asking Price</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {listings.map((item) => (
                <tr key={item.name}>
                  <td>{item.name}</td>
                  <td>{item.location}</td>
                  <td>{item.type}</td>
                  <td>{item.beds}</td>
                  <td>{item.price}</td>
                  <td>
                    <span
                      className={`listing-status ${item.status
                        .toLowerCase()
                        .replaceAll(" ", "-")}`}
                    >
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

/* =========================================================
   BUY CARE HOME
========================================================= */

const BuyCareHome = () => {
    const [activeTab, setActiveTab] = useState("buy");
  return (
    <section className="care-business-section">
      <div className="section-container looking-container">
        <span className="section-label">WHAT ARE YOU LOOKING TO DO?</span>

        <h2>Care home sales handled properly.</h2>

        <p>
          Whether you're looking to acquire your next care business or sell an
          existing operation, our specialist team
          <br className="desktop-break" />
          can support you from the first conversation through to completion.
        </p>
      </div>
      <div className="care-business-container">
        {/* Tabs */}
        <div className="care-tabs">
          <button
            className={`care-tab ${activeTab === "buy" ? "active" : ""}`}
            onClick={() => setActiveTab("buy")}
          >
            <span className="tab-number">01</span>
            <span>I want to buy a care home</span>
          </button>

          <button
            className={`care-tab ${activeTab === "sell" ? "active" : ""}`}
            onClick={() => setActiveTab("sell")}
          >
            <span className="tab-number">02</span>
            <span>I want to sell a care home</span>
          </button>
        </div>

        {/* BUY SECTION */}
        {activeTab === "buy" && (
          <div className="care-content buy-content">
            <div className="care-text">
              <span className="small-heading">BUY A CARE HOME</span>

              <h2>
                Find the right care
                business for your goals.
              </h2>

              <p>
                Finding the right care home is about more than location and
                price. We help buyers understand the opportunity, assess the
                business and navigate the acquisition process.
              </p>

              <ul className="care-list">
                <li>Access suitable care home opportunities</li>
                <li>Understand financial and operational performance</li>
                <li>Support with valuation and negotiations</li>
                <li>Assistance through due diligence</li>
                <li>End-to-end transaction support</li>
              </ul>

              <button className="primary-btn">
                <a href="#final-cta">Discuss Your Requirements</a>
                <span>→</span>
              </button>
            </div>

            {/* Opportunities Card */}
            <div className="opportunity-card">
              <div className="opportunity-header">
                <span>AVAILABLE OPPORTUNITIES</span>
                <strong>28</strong>
              </div>

              <div className="opportunity-item">
                <div>
                  <h4>Greenfield Care Home</h4>
                  <small>Surrey · 45 Beds</small>
                </div>
                <strong>£1.85M</strong>
              </div>

              <div className="opportunity-item">
                <div>
                  <h4>Riverside Care Home</h4>
                  <small>Birmingham · 30 Beds</small>
                </div>
                <strong>£950K</strong>
              </div>

              <div className="opportunity-item">
                <div>
                  <h4>Woodlands Care Home</h4>
                  <small>Leeds · 42 Beds</small>
                </div>
                <strong>£1.65M</strong>
              </div>
            </div>
          </div>
        )}

        {/* SELL SECTION */}
        {activeTab === "sell" && (
          <div className="care-content sell-content">
            {/* Valuation Card */}
            <div className="valuation-wrapper">
              <div className="valuation-card">
                <span className="small-heading">ESTIMATED MARKET VALUE</span>

                <h3>£1.42M</h3>

                <p className="valuation-note">
                  Indicative valuation based on current market conditions
                </p>

                <div className="valuation-progress">
                  <span></span>
                </div>

                <div className="valuation-row">
                  <span>Occupancy</span>
                  <strong>91%</strong>
                </div>

                <div className="valuation-row">
                  <span>Annual Revenue</span>
                  <strong>£2.8M</strong>
                </div>

                <div className="valuation-row">
                  <span>EBITDA</span>
                  <strong>£620K</strong>
                </div>
              </div>
            </div>

            <div className="care-text sell-text">
              <span className="small-heading">SELL YOUR CARE HOME</span>

              <h2>
                Get the right value
                for your care business.
              </h2>

              <p>
                Selling a care home is a major decision. Our experienced team
                helps you understand your property's market position, prepare
                the opportunity and identify suitable buyers.
              </p>

              <ul className="care-list">
                <li>Confidential initial valuation</li>
                <li>Market positioning and preparation</li>
                <li>Targeted buyer introductions</li>
                <li>Offer management and negotiation</li>
                <li>Support through completion</li>
              </ul>

              <button className="primary-btn">
                <a href="#final-cta">Request a Confidential Valuation</a>
                
                <span>→</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

/* =========================================================
   WHY TOTAL CARE
========================================================= */

const WhyTotalCare = () => {
  return (
    <section className="why-sections">
      <div className="section-container">
        <div className="center-heading">
          <span className="section-label">WHY TOTAL CARE ADVISORY?</span>

          <h2>More than a transaction. A specialist partner.</h2>

          <p>
            Our understanding of the care sector means we look beyond the
            property to understand the business,
            <br className="desktop-break" />
            operations and opportunities behind every transaction.
          </p>
        </div>

        <div className="reason-grid">
          {reasons.map((item) => (
            <div className="reason-card" key={item.number}>
              <span>{item.number}</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* =========================================================
   PROCESS HEADING
========================================================= */

const ProcessHeading = () => {
  return (
    <section className="process-heading">
      <div className="section-container center-heading">
        <span className="section-label">OUR PROCESS</span>

        <h2>A clear route from enquiry to completion.</h2>

        <p>
          We keep the process structured, transparent and focused on your
          objectives.
        </p>
      </div>
    </section>
  );
};

/* =========================================================
   PROCESS STEPS
========================================================= */

const ProcessSteps = () => {
  return (
    <section className="process-steps">
      <div className="section-container">
        <div className="process-grid">
          {processSteps.map((step) => (
            <div className="process-card" key={step.number}>
              <span className="process-number">{step.number}</span>

              <div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* =========================================================
   FEATURED OPPORTUNITIES
========================================================= */

const FeaturedOpportunities = () => {
  return (
    <section className="featured-section" id="featured">
      <div className="section-container">
        <span className="section-label">FEATURED OPPORTUNITIES</span>

        <h2>
          Care homes currently
          <br className="desktop-break" />
          available.
        </h2>

        <div className="featured-grid">
          {opportunities.map((item) => (
            <article className="featured-card" key={item.name}>
              <div className="featured-image">
                <img src={item.image} alt={item.name} />

                <span
                  className={
                    item.status === "Under Offer" ? "under-offer" : "for-sale"
                  }
                >
                  {item.status}
                </span>
              </div>

              <div className="featured-body">
                <div className="featured-title">
                  <h3>{item.name}</h3>
                  <strong>{item.price}</strong>
                </div>

                <p className="featured-location">{item.location}</p>

                <div className="featured-tags">
                  <span>{item.type}</span>
                  <span>{item.beds}</span>
                </div>

                <button>View Opportunity →</button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

/* =========================================================
   STATS
========================================================= */

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((stat) => (
          <div className="stat-item" key={stat.label}>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

/* =========================================================
   FAQ
========================================================= */

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq-sections">
      <div className="faq-container">
        <div className="Faq-area">
          <p>QUESTIONS</p>
          <h2>Care home sales FAQs.</h2>
          <h3>
            Some of the questions we're most commonly asked by buyers and
            sellers.
          </h3>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => {
            const open = openIndex === index;

            return (
              <div
                className={`faq-item ${open ? "open" : ""}`}
                key={faq.question}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                >
                  <span>{faq.question}</span>

                  <strong>{open ? "−" : "+"}</strong>
                </button>

                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* =========================================================
   FINAL CTA
========================================================= */

const FinalCTA = () => {
  return (
    <section className="final-cta" id="final-cta">
      <div className="final-cta-container">
        <span>READY TO TAKE THE NEXT STEP?</span>

        <h2>Let's talk about your care home.</h2>

        <p>
          Whether you're considering selling, looking to acquire a care business
          or simply want to
          <br className="desktop-break" />
          understand your options, our team is here to help.
        </p>

        {/* <div className="cta-actions">
          <a
            href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
            className="talk-btn-first"
          >
            Book a Free Consultation
          </a>
          <a href="tel:+440000000000" className="talk-btn-second">
            Request a Valuation
          </a>
        </div> */}
        <div className="cta-actions">
          <a
            href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
            className="talk-btn-first"
          >
            Book a Free Consultation
          </a>

          <a href="tel:+440000000000" className="talk-btn-second">
            Request a Valuation
          </a>
        </div>
      </div>
    </section>
  );
};

/* =========================================================
   MAIN PAGE
========================================================= */

const Care_Home = () => {
  return (
    <main className="care-home-sales-page">
      <SalesHero />
      <BuyCareHome />
      <WhyTotalCare />
      <ProcessHeading />
      <ProcessSteps />
      <FeaturedOpportunities />
      <StatsSection />
      <FAQSection />
      <FinalCTA />
    </main>
  );
};

export default Care_Home;
